import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { Subscription } from "rxjs";
import { UtilService } from "src/app/services/util.service";
import { ResponseAPI, UserType, User, EnterInLineViewModel } from "src/models/user.model";
import { LoadingController, AlertController, Platform } from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { AuthService } from "src/app/services/auth.service";
import { TipoCorrida } from "src/models/corrida.model";
import { NavigationExtras, Router } from "@angular/router";
import { StatusCorrida, StatusCorridaFilter } from "src/models/reserva.model";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Languages } from "../../../models/language.model";
import { SignalRService } from '../../services/signalr.service';

@Component({
    selector: "app-scheduled-trips",
    templateUrl: "./scheduled-trips.page.html",
    styleUrls: ["./scheduled-trips.page.scss"],
    standalone: false
})
export class ScheduledTripsPage implements OnDestroy {
  sub: Subscription;
  listHistory = [];
  claim: UserType;
  userType = UserType;
  TipoCorrida = TipoCorrida;
  user: User;
  status = StatusCorrida;
  offset: number;
  isOpenCanceling: boolean;
  formCancelation: UntypedFormGroup;
  filterForm: UntypedFormGroup;
  showModalFilter: boolean = false;
  todosStatus = Object.keys(StatusCorridaFilter).map((key) => ({
    id: StatusCorridaFilter[key],
    name: key,
  }));
  isFiltered: boolean = false;
  Languages = Languages;
  tripInterval: NodeJS.Timeout;
  enterInLineViewModel = {} as EnterInLineViewModel;
  constructor(
    private crud: CrudService,
    private util: UtilService,
    private loadCtrl: LoadingController,
    public alertController: AlertController,
    public route: Router,
    private platform: Platform,
    private auth: AuthService,
    private fb: UntypedFormBuilder,
    private _ngZone: NgZone,
    private _signalRService: SignalRService
  ) {
    this.formCancelation = this.fb.group({
      motivoCancelamento: [""],
      id: [""],
      canceladoPor: [this.auth.user.name],
      voltarParaEmDisputa: [false],
    });
  }

  async ionViewWillEnter() {
    this.filterForm = this.fb.group({
      nomeCliente: [""],
      dataInicio: [""],
      dataFim: [""],
      status: [""],
    });
    this.offset = this.changeTimezone(
      new Date(
        new Date().toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })
      ),
      "America/New_York"
    ).getTimezoneOffset();

    this.claim = await this.auth.getClaim();
    this.user = this.auth.user;
    await this.showLoading();
    if (this.claim === UserType.Driver) {
      this.enterInLineViewModel.driverId = this.user.id;
      if (!this._signalRService.driverIsInLine) {
        await this._signalRService.setUpConnection(this.enterInLineViewModel);
        await this._signalRService.setDriverConnectOnly(this.enterInLineViewModel);
      }
      await this._signalRService.getDriverTripsInDispute(async (trip) => {
        console.log(trip);
        // await this.loadCtrl.dismiss();
        this.listHistory = trip
      });
    }
    await this.loadData(null, false);

    // this.tripInterval = setInterval(async () => {
    //   await this.loadData(null, false);
    // }, 5000);
  }

  async postReason() {
    if (this.formCancelation.invalid) {
      return false;
    }
    await this.showLoading();
    this.crud
      .postData("Corrida/cancelar-corrida", null, this.formCancelation.value)
      .subscribe(
        async (response: ResponseAPI) => {
          if (response.success) {
            this.isOpenCanceling = false;
            await this.loadData(null, false);
            await this.loadCtrl.dismiss();
            await this.util.showToast("Your information has been sent.");
          }
        },
        async (error) => {
          this.isOpenCanceling = false;
          await this.loadData(null, false);
          await this.loadCtrl.dismiss();
          await this.util.showToast("An error occured");
        }
      );
  }
  private changeTimezone(date, ianatz) {
    // suppose the date is 12:00 UTC
    var invdate = new Date(
      date.toLocaleString("en-US", {
        timeZone: ianatz,
      })
    );

    // then invdate will be 07:00 in Toronto
    // and the diff is 5 hours
    var diff = date.getTime() - invdate.getTime();

    // so 12:00 in Toronto is 17:00 UTC
    return new Date(date.getTime() - diff); // needs to substract
  }

  getCardColor(item) {
    if (item.statusCorrida === this.status.CANCELLED) return "CANCELLED";
    if (item.statusCorrida === this.status.ACCEPTED) return "ACCEPTED";
    if (item.statusCorrida === this.status.PENDING) return "REQUESTED";
    if (item.statusCorrida === this.status.DISPUTED) return "DISPUTED";
    if (item.statusCorrida === this.status.FINISHED) {
      if (item.tipoCorrida === TipoCorrida.IDAVOLTA) return "ROUNDTRIP";
      if (item.masterReceber && item.masterReceber.id === this.user.id)
        return "MASTER";
      return "FINISHED";
    }
  }

  // Builds the share text for a scheduled trip. While the trip is still waiting
  // for a driver, sharing incomplete details is misleading — instead share an
  // informative message (test report: Scheduled Trip Request "Share" button).
  buildShareText(item: any): string {
    const hasDriver = !!(item?.motorista && (item.motorista.nome || item.motorista.id));
    if (!hasDriver) {
      return "This trip is still awaiting driver acceptance. As soon as a driver accepts, the information will be updated automatically.";
    }

    const dt = item?.dataAgendamentoCorrida
      ? new Date(item.dataAgendamentoCorrida).toLocaleString("en-US", { hour12: true })
      : "";
    const valor = item?.saldo?.valorCorrida ?? 0;
    const driver = item.motorista;
    const veiculo = driver?.veiculo;
    const carParts = [veiculo?.ano, veiculo?.marca, veiculo?.modelo, veiculo?.cor]
      .filter(Boolean)
      .join(" ");

    return (
      "GoSpread scheduled trip\n" +
      `Passenger: ${item?.nomePassageiro ?? ""}\n` +
      `From: ${item?.enderecoOrigem ?? ""}\n` +
      `To: ${item?.enderecoDestino ?? ""}\n` +
      (dt ? `When: ${dt}\n` : "") +
      `Price: $${Number(valor).toFixed(2)}\n` +
      `Driver: ${driver?.nome ?? ""}\n` +
      `Driver phone: ${driver?.celular ?? ""}` +
      (carParts ? `\nVehicle: ${carParts}` : "") +
      (veiculo?.placa ? `\nPlate: ${veiculo.placa}` : "")
    );
  }

  async shareTrip(item: any): Promise<void> {
    if (!item) return;
    const text = this.buildShareText(item);
    const nav = navigator as any;
    try {
      if (nav?.share) {
        await nav.share({ title: "GoSpread Trip", text });
        return;
      }
    } catch (_) {
      // fall through to clipboard
    }
    try {
      if (nav?.clipboard?.writeText) {
        await nav.clipboard.writeText(text);
      }
      await this.util.showToast("Trip details copied to clipboard.");
    } catch (_) {
      await this.util.showToast("Unable to share. Please copy manually.");
    }
  }

  cancelRace(trip): void {
    this.formCancelation = this.fb.group({
      motivoCancelamento: [""],
      id: [trip.id],
      canceladoPor: [this.auth.user.name],
    });
    this._ngZone.run(() => {
      this.isOpenCanceling = true;
    });
  }

  async acceptTrip(race) {
    await this.showLoading();
    this.crud.putData(`corrida/aceitar-em-disputa/${race.id}`, null).subscribe(
      async () => {
        await this.util.showToast("Trip accepted successfully");
        await this.loadCtrl.dismiss();
        // Refresh so the just-accepted trip drops off the list; otherwise the
        // stale card stays and re-tapping it returns "already accepted".
        await this.loadData(null, false);
      },
      async (err: any) => {
        // Surface the actual server reason instead of the misleading
        // "already accepted by another driver" fallback. The backend now
        // returns { success, code, errors: [string] } on rejection.
        const serverMsg = err?.error?.errors?.[0]
          ?? err?.error?.message
          ?? (err?.status === 0 ? "Network error — please check your connection." : null);
        const fallback = err?.status === 400
          ? "This trip is no longer available."
          : "Could not accept the trip. Please try again.";
        await this.util.showToast(serverMsg ?? fallback);
        await this.loadCtrl.dismiss();
      }
    );
  }
  setDestinyComplete(destiny: object): string {
    return `${destiny["nomeRua"]}, ${destiny["bairro"]}`;
  }

  async loadData(event: any, filtered: boolean) {
    if (!filtered) {
      this.filterForm.reset();
    }
    this.sub = this.crud
      .getData(
        this.claim === UserType.Driver
          ? "Corrida/driver/em-disputa"
          : "Corrida/spreader/em-disputa",
        null,
        this.filterForm.value
      )
      .subscribe(
        async (response: any) => {
          console.log(response);
          this.isFiltered = filtered;
          this.listHistory = response;
          if (event) {
            event.target.complete();
          }

          await this.loadCtrl.dismiss();
        },
        async (error) => {
          if (event) {
            event.target.complete();
          }
          await this.loadCtrl.dismiss();
        }
      );
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadCtrl.create(loadingProps);
    return await loading.present();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    clearInterval(this.tripInterval);
  }
  showFilter() {
    this.filterForm.reset();
    this.showModalFilter = true;
  }

  ionViewWillLeave() {
    this.sub.unsubscribe();
    clearInterval(this.tripInterval);
  }

  filterData(event, filtered: boolean) {
    this.loadData(event, filtered);
    this.showModalFilter = false;
  }
}
